import React from "react";
import { ExpandableSection } from "@amzn/awsui-components-react";
import { AssistantStep } from "features/assistant/definitions";
import StepsContent from "./StepsContent";
import styles from "../style.module.scss";

const StepsDropdown: React.FC<{ steps: AssistantStep[] }> = ({ steps }) => {
  if (steps.length === 0) {
    return null;
  }
  return (
    <div className={styles.stepsDropdown}>
      <ExpandableSection
        headerText="Steps taken by AI Agents"
        variant="footer"
        defaultExpanded
      >
        <StepsContent steps={steps} />
      </ExpandableSection>
    </div>
  );
};

export default StepsDropdown;
